import React from 'react';

import TInputHelper from './TInputHelper';
import { TextBodySmall } from '../../components/Text';

const InputHelper = ({ children, id }: TInputHelper) => (
  <TextBodySmall as="span" color="text-secondary" name="helper" id={id}>
    {children}
  </TextBodySmall>
);

export default InputHelper;
